import React from "react";
import InvalidMessage from "venuescanner-js/react/components/Form/Notifications/InvalidMessage";
// import placeholders from 'venuescanner-js/react/components/Form/copy/placeholders'
import classes from "./Radio.module.scss";
import cl from "classnames";
function Radio(props) {
  const {
    errors = {},
    touched = {},
    label: formLabel,
    name,
    register,
    handleChange,
    value: formakValue,
    options = [],
  } = props;

  return (
    <div
      className={cl([
        classes.radio,
        { "form-error": errors[name] && (!touched || touched[name]) },
      ])}
    >
      {formLabel && <label>{formLabel}</label>}
      {options.map((option, index) => {
        const { value, label } =
          typeof option === "string"
            ? { value: option, label: option }
            : option;
        return (
          <div className={classes.radio_option} key={`${name}-${index}`}>
            <input
              type="radio"
              name={name}
              id={`${name}-${index}`}
              value={value}
              onChange={handleChange}
              checked={formakValue === value}
            />
            <label
              className={cl({ [classes.cross]: option.cross })}
              htmlFor={`${name}-${index}`}
            >
              {label}
            </label>
          </div>
        );
      })}
      <InvalidMessage error={(!touched || touched[name]) && errors[name]} />
    </div>
  );
}

export default Radio;
